import * as api from "../api";
import toast from "react-hot-toast";
import { DateFormatter2 } from "../../helpers/DateFormatter2";
import dayjs from "dayjs";

export const GET_PENDING_WITHDRAWL_REQUEST = "GET_PENDING_WITHDRAWL_REQUEST";
export const CLEAR_PENDING_WITHDRWAL_REQUEST =
  "CLEAR_PENDING_WITHDRWAL_REQUEST";
export const GET_PENDING_BATCHES = "GET_PENDING_BATCHES";
export const CLEAR_PENDING_BATCHES = "CLEAR_PENDING_BATCHES";

export const getPendingWithdrawlRequest = () => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetPendingWithdrawlRequest(accessToken);
    let dataArray = [];
    response.data.forEach((item) => {
      const formattedDate = DateFormatter2(item.createdDate);
      const tempArray = [
        item.id,
        item.customerId,
        item.customerName,
        item.amount,
        formattedDate,
        item.collectorName,
        item.id,
      ];
      dataArray = [...dataArray, tempArray];
    });
    dispatch({
      type: GET_PENDING_WITHDRAWL_REQUEST,
      payload: dataArray,
    });
  } catch (err) {
    toast.error(err.response ? err.response.data?.message : err.message);
  }
};

export const clearPendingWithdrawlRequests = () => {
  return { type: CLEAR_PENDING_WITHDRWAL_REQUEST };
};

export const approveWithdrawlRequest =
  (transactionId, handleSuccess, handleFailure) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiApproveWithdrawlRequest(
        accessToken,
        transactionId
      );
      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

const convertToArrayPendingBatch = (responseData) => {
  let dataArray = [];

  responseData.forEach((item) => {
    const formattedDate =
      item.date === null ? "-" : dayjs(item.date).format("DD MMMM, YYYY");
    const tempArray = [
      item.batch_id,
      item?.collector?.name ?? "",
      item?.collector?.mobileNumber ?? "",
      formattedDate,
      item?.status,
      item?.totalTransaction ?? 0,
    ];
    dataArray = [...dataArray, tempArray];
  });
  return dataArray;
};

export const getPendingBatches = (status) => async (dispatch, getState) => {
  try {
    const {
      user: { accessToken },
    } = getState();
    const response = await api.apiGetPendingBatchRequest(accessToken, status);
    const finalPayloadArray = convertToArrayPendingBatch(response.data);
    dispatch({
      type: GET_PENDING_BATCHES,
      payload: finalPayloadArray,
    });
  } catch (err) {
    toast.error(err.response ? err.response.data?.message : err.message);
  }
};

export const clearPendingBatches = () => {
  return { type: CLEAR_PENDING_BATCHES };
};

